<script>
    import RepTable from './RepTable.svelte';
    import Photos from './../Photos.svelte';
    import IssueCard from './IssueCard.svelte';
    import StaticMap from './StaticMap.svelte';
    import { staticMapURLsDict } from '../../stores';
    import PrintSection from "./PrintSection.svelte";
    import { byLocale, __, t, __c } from "../../utils/i18n";
    import { districtNames } from "../../utils/copy";

    /**
     * @type {any[]}
     */
    export let data;
    /**
     * @type {any[]}
     */
    export let issuesList;

     /**
   * @type {boolean}
   */
   export const isCity = false;
        /**
   * @type {string}
   */
   export const cityName = false;
   /**
   * @type {any[]}
   */
   export let zonesContent;

  //  console.log('federal level zones content:', zonesContent);
  
    let name = t(districtNames, 'congressional', {id: data.id});
    let value = data.id;

  let headers = [name, 'Senators'];
  let reps = [[data], data.reps];
  reps[0][0]['office'] = 'U.S. representative';
  
  </script>
  
  <section>
    <div class="section congressional" id="federal">
      <div class="title-map">
        <div class="hide-on-desktop hide-on-tablet">
          {@html byLocale(zonesContent, 'heading')}
        </div>
        <StaticMap
          url={$staticMapURLsDict['congressional']}
          altText={__('Map of ') + name + __(' outlined.')}
          lazyLoad="false"
        />
      </div>
      <div class="content">
        <div class="hide-on-mobile">
          {@html byLocale(zonesContent, 'heading')}
        </div>
          {@html byLocale(zonesContent, 'content')}
        <Photos
          lookup='parksign'
          className = "main-page-img smaller-verticals"
          idName = "parksign"
          ariaHidden = "false"
          lazyLoad = "false"
          />
      </div>
      <div class="content contd">
        {#each issuesList as i}
          <IssueCard issue={i} level="federal" city=None inc=None />
        {/each}
        <RepTable {reps} {headers} />
      </div>

    </div>
  </section>

  <PrintSection {reps} {headers} heading={zonesContent[`${__c("heading")}`]} {name} level="congressional"/>